(() => {
  const loader = document.currentScript;
  if (!loader) return;

  const librarySource = loader.dataset.librarySrc;
  const gallerySource = loader.dataset.gallerySrc;
  let loading;

  const loadScript = (source) =>
    new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = source;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

  const loadGallery = () => {
    if (window.productPhotoSwipeReady) return Promise.resolve();
    if (loading) return loading;

    loading = loadScript(librarySource)
      .then(
        () =>
          new Promise((resolve, reject) => {
            const handleReady = () => {
              window.removeEventListener('product-photoswipe:ready', handleReady);
              resolve();
            };

            window.addEventListener('product-photoswipe:ready', handleReady, { once: true });
            loadScript(gallerySource).catch(reject);
          })
      )
      .catch((error) => {
        loading = undefined;
        throw error;
      });

    return loading;
  };

  const isGalleryInteraction = (target) => {
    if (!(target instanceof Element)) return false;
    if (target.closest('.product-gallery-photoswipe__trigger')) return true;

    return (
      !window.ZOOM &&
      target.matches('.product-image-main .product-media.media-image > img')
    );
  };

  ['pointerenter', 'touchstart', 'focusin'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        if (isGalleryInteraction(event.target)) loadGallery().catch(() => {});
      },
      true
    );
  });

  document.addEventListener(
    'click',
    (event) => {
      if (!isGalleryInteraction(event.target) || window.productPhotoSwipeReady) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const target = event.target;

      loadGallery()
        .then(() => target.click())
        .catch(() => {});
    },
    true
  );
})();
